export const DEFAULT_MAX_DAYS = 2
export const ms = 1000
export const secInMin = 60
export const minInHour = 60
export const hourInDay = 24
export const DAY_IN_MS = hourInDay * minInHour * secInMin * ms
